<template>
  <div class="invoice">
    <div class="invoice-top">
      <div class="typeList-content">
        <div class="title">发票类型</div>
        <div class="typeList">
          <div
            :class="['item', invoice.type==0?'active':'']"
            @click="typeToggle(0)"
          >不开发票
          </div>
          <div
            :class="['item', invoice.type==2?'active':'']"
            @click="typeToggle(2)"
          >普通发票
          </div>
        </div>
        <div class="ps">
          <span>*开发票需缴纳6%的税点</span>
          <br>*发票信息确定提交后，客服将在1-3个工作日内联系您</div>
      </div>
      <div
        class="ordinary-type"
        v-if="invoice.type==2"
      >
        <div class="item">
          <div class="key">抬头类型</div>
          <div class="value rise">
            <div
              class="personal"
              @click="riseToggle(1)"
            >
              <img
                v-if="invoice.rise==1"
                src="../../../assets/images/updataFile/select-active.png"
              >
              <img
                v-else
                src="../../../assets/images/updataFile/select.png"
              >
              个人</div>
            <div
              class="enterprise"
              @click="riseToggle(2)"
            ><img
                v-if="invoice.rise==2"
                src="../../../assets/images/updataFile/select-active.png"
              >
              <img
                v-else
                src="../../../assets/images/updataFile/select.png"
              >企业</div>
          </div>
        </div>
        <div
          class="item"
          v-if="invoice.rise==2"
        >
          <div class="key">企业名称</div>
          <div class="value">
            <input
              type="text"
              placeholder="请输入企业名称"
              v-model="invoice.enterpriseName"
            >
          </div>
        </div>
        <div
          class="item"
          v-if="invoice.rise==2"
        >
          <div class="key">纳税人标识码</div>
          <div class="value">
            <input
              type="text"
              placeholder="请输入纳税人标识码"
              v-model="invoice.code"
            >
          </div>
        </div>
      </div>
    </div>
    <div class="invoice-bottom">
      <div
        class="mask"
        v-show="saveInvoiceFlag"
      >
        <div class="mask-content">
          <img
            src="../../../assets/images/updataFile/shutIcon.png"
            alt="关闭"
            @click="saveInvoicePopup"
            class="shut"
          >
          <div class="title">核对信息</div>
          <div class="direction">请仔细核对开票信息，提供的信息错误导致发票退回重开所产生的快递费用需自行承担。</div>
          <div class="btn">
            <div
              @click="saveInvoiceFun"
              class="yes"
            >确认无误</div>
            <div
              @click="saveInvoicePopup"
              class="no"
            >返回核对</div>
          </div>
        </div>
      </div>
      <div class="serve-phone">客服电话：<a href="tel:020-82514696">020-82514696</a></div>
      <div
        class="saveBtn"
        @click="save"
      >保存</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      invoice: {
        type: 0,
        rise: 1
      },
      saveInvoiceFlag: false
    };
  },
  created() {
    if (sessionStorage.getItem("invoice"))
      this.invoice = JSON.parse(sessionStorage.getItem("invoice"));
    if (this.$route.query.orderNo) this.$wxConfig(this.$route.query.doctorsId);
  },
  methods: {
    /**
     * 打开或关闭核对信息弹窗
     */
    saveInvoicePopup() {
      this.saveInvoiceFlag = !this.saveInvoiceFlag;
      this.$store.state.closureFlag = true;
    },
    saveInvoiceFun() {
      sessionStorage.setItem("invoice", JSON.stringify(this.invoice));
          if (this.$route.query.orderNo&&this.invoice.type!=0) {
        // 发起支付，支付开票的费用
        let data = this.invoice;
        data.userId = JSON.parse(localStorage.getItem("userInfo")).id;
        data.orderNo = this.$route.query.orderNo;
        this.wxPayment(data);
        return;
      } else {
        this.$tootsSuccess("保存成功");
      }
      setTimeout(() => {
        this.$router.go(-1);
      }, 1500);
    },
    /**
     * 开票类型切换
     */
    typeToggle(type) {
      if (type == 2) {
        this.invoice.rise = 1;
      }
      this.invoice.type = type;
    },
    /**
     * 开票抬头切换
     */
    riseToggle(rise) {
      this.invoice.rise = rise;
    },
    /**
     * 点击保存
     */
    save() {
      if (this.$store.state.closureFlag) {
        this.$store.state.closureFlag = false;
        let invoice = this.invoice;
        if (invoice.type == 2 && invoice.rise == 2) {
          if (!invoice.enterpriseName) this.$toots("请输入企业名称");
          else if (!invoice.code) this.$toots("请输入纳税人标识码");
          else this.saveInvoicePopup();
        } else {
          sessionStorage.setItem(
            "invoice",
            JSON.stringify({
              type: invoice.type,
              rise: invoice.rise
            })
          );
          if (this.$route.query.orderNo&&invoice.type!=0) {
            // 发起支付，支付开票的费用
            let data = this.invoice;
            data.userId = JSON.parse(localStorage.getItem("userInfo")).id;
            data.orderNo = this.$route.query.orderNo;
            this.$loading()
            this.wxPayment(data);
            return
          } else {
            this.$tootsSuccess("保存成功");
          }
          setTimeout(() => {
            this.$router.go(-1);
          }, 1500);
        }
      }
    },

    /**
     * 调用微信支付
     */
    wxPayment(data) {
      this.$http
        .post(`/wechat/createInvoiceOrder`, data, { qs: "no" })
        .then(res => {
          if (res.data.code == 200) {
            let data = res.data.data;
            let timeStamp = data.timeStamp;
            let nonceStr = data.nonceStr;
            let packageValue = data.packageValue;
            let signType = data.signType;
            let paySign = data.paySign;
            this.wx.chooseWXPay({
              timestamp: timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
              nonceStr: nonceStr, // 支付签名随机串，不长于 32 位
              package: packageValue, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
              signType: signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
              paySign: paySign, // 支付签名
              success: res => {
                // 支付成功后的回调函数
                this.$store.state.loadingFlag = false;
                this.$store.state.closureFlag = true;
                this.$router.go(-1);
              },
              fail: err => {
                this.$toots("系统正在升级，请稍后");
              },
              cancel: cancel => {
                this.$toots("取消支付");
              }
            });
          } else if (res.data.code == 500) this.$toots(res.data.msg);
        })
        .catch(err => {
          this.$toots("系统正在升级，请稍后");
        });
    }
  }
};
</script>
<style lang="less" scoped>
.invoice {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;
  padding: 30px;
  .invoice-top {
    flex: 1;
    border-radius: 6px;
    /* 选择发票类型 */
    .typeList-content {
      padding-left: 30px;
      padding-right: 30px;
      padding-top: 50px;
      background-color: #fff;
      border-radius: 10px;
      .title {
        font-size: 32px;
        font-weight: 700;
        padding-bottom: 20px;
      }
      .typeList {
        display: flex;
        justify-content: space-between;
        .item {
          width: 300px;
          height: 116px;
          line-height: 116px;
          border: 1PX solid #e6e6e6;
          color: #666666;
          font-size: 30px;
          text-align: center;
          position: relative;
          border-radius: 10px;
        }
        .item.active {
          color: #1968a8;
          border-color: #1968a8;
        }
      }
      .ps {
        padding-top: 20px;
        padding-bottom: 20px;
        font-size: 26px;
        line-height: 40px;
        color: #aaa;
        span {
          color: #666;
        }
      }
    }
    .ordinary-type {
      background-color: #fff;
      margin-top: 20px;
      padding-left: 30px;
      border-radius: 10px;
      .item:last-child {
        border-bottom: none;
      }
      .item {
        display: flex;
        justify-content: space-between;
        height: 108px;
        line-height: 108px;
        border-bottom: 1PX solid #eee;
        font-size: 28px;
        .key {
          width: 200px;
        }
        .value {
          flex: 1;
          input {
            width: 100%;
            font-size: 28px;
            height: 50%;
          }
          input::placeholder {
            color: #ccc;
          }
        }
        .rise {
          display: flex;
          .personal {
            margin-right: 70px;
          }
          img {
            width: 40px;
            height: 40px;
            vertical-align: middle;
            margin-bottom: 4px;
            margin-right: 10px;
          }
        }
      }
    }
  }
  /* 底部联系方式与保存 */
  .invoice-bottom {
    height: 260px;
    padding-top: 62px;
    padding-bottom: 32px;
    .serve-phone {
      background: #f6f6f6;
      font-size: 26px;
      text-align: center;
      a {
        font-weight: bold;
        color: #1968a8;
      }
    }
    .direction {
      line-height: 48px;
      text-align: justify;
      padding: 30px;
    }
    .saveBtn {
      width: 658px;
      height: 88px;
      line-height: 88px;
      border-radius: 88px;
      margin: 0 auto;
      margin-top: 50px;
      font-size: 32px;
      background-color: #1968a8;
      text-align: center;
      color: #fff;
    }
  }
}
</style>
